function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { RoundedRectangle } from "../render/RoundedRectangle";
import { Container } from "./Container";
import { Graphics } from "./Graphics";
import { Button } from "./Button";
import * as $type from "../util/Type";
import * as $utils from "../util/Utils";
/**
 * A control that allows zooming chart's axes, or other uses requiring range
 * selection.
 *
 * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/} for more info
 */
export var Scrollbar = /*#__PURE__*/function (_Container) {
  _inherits(Scrollbar, _Container);
  var _super = _createSuper(Scrollbar);
  function Scrollbar() {
    var _this;
    _classCallCheck(this, Scrollbar);
    _this = _super.apply(this, arguments);
    /**
     * A thumb elment - a draggable square between the grips, used for panning
     * the selection.
     */
    Object.defineProperty(_assertThisInitialized(_this), "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._makeThumb()
    });
    /**
     * Start grip button.
     */
    Object.defineProperty(_assertThisInitialized(_this), "startGrip", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._makeButton()
    });
    /**
     * End grip button.
     */
    Object.defineProperty(_assertThisInitialized(_this), "endGrip", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._makeButton()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_thumbBusy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_startDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_endDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_thumbDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_gripDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(Scrollbar, [{
    key: "_addOrientationClass",
    value: function _addOrientationClass() {
      this._settings.themeTags = $utils.mergeTags(this._settings.themeTags, ["scrollbar", this._settings.orientation]);
      if (!this._settings.background) {
        this._settings.background = RoundedRectangle.new(this._root, {
          themeTags: $utils.mergeTags(this._settings.themeTags, ["main", "background"])
        });
      }
    }
  }, {
    key: "_makeButton",
    value: function _makeButton() {
      return this.children.push(Button.new(this._root, {
        themeTags: ["resize", "button", this.get("orientation")],
        icon: Graphics.new(this._root, {
          themeTags: ["icon"]
        })
      }));
    }
  }, {
    key: "_makeThumb",
    value: function _makeThumb() {
      return this.children.push(RoundedRectangle.new(this._root, {
        themeTags: ["thumb", this.get("orientation")]
      }));
    }
  }, {
    key: "_handleAnimation",
    value: function _handleAnimation(animation) {
      var _this2 = this;
      if (animation) {
        this._disposers.push(animation.events.on("stopped", function () {
          _this2.setPrivateRaw("isBusy", false);
          _this2._thumbBusy = false;
        }));
      }
    }
  }, {
    key: "_afterNew",
    value: function _afterNew() {
      var _this3 = this;
      this._addOrientationClass();
      _get(_getPrototypeOf(Scrollbar.prototype), "_afterNew", this).call(this);
      var startGrip = this.startGrip;
      var endGrip = this.endGrip;
      var thumb = this.thumb;
      var background = this.get("background");
      if (background) {
        this._disposers.push(background.events.on("click", function (event) {
          _this3.setPrivateRaw("isBusy", true);
          var point = _this3._display.toLocal(event.point);
          var w = _this3.width();
          var h = _this3.height();
          var orientation = _this3.get("orientation");
          var newMiddle;
          if (orientation == "vertical") {
            newMiddle = (point.y - thumb.height() / 2) / h;
          } else {
            newMiddle = (point.x - thumb.width() / 2) / w;
          }
          var newCoordinate;
          var key;
          if (orientation == "vertical") {
            newCoordinate = newMiddle * h;
            key = "y";
          } else {
            newCoordinate = newMiddle * w;
            key = "x";
          }
          var duration = _this3.get("animationDuration", 0);
          if (duration > 0) {
            _this3._thumbBusy = true;
            _this3._handleAnimation(_this3.thumb.animate({
              key: key,
              to: newCoordinate,
              duration: duration,
              easing: _this3.get("animationEasing")
            }));
          } else {
            _this3.thumb.set(key, newCoordinate);
            _this3._root.events.once("frameended", function () {
              _this3.setPrivateRaw("isBusy", false);
            });
          }
        }));
      }
      this._disposers.push(thumb.events.on("dblclick", function (event) {
        if (!$utils.isLocalEvent(event.originalEvent, _this3)) {
          return;
        }
        var duration = _this3.get("animationDuration", 0);
        var easing = _this3.get("animationEasing");
        _this3.animate({
          key: "start",
          to: 0,
          duration: duration,
          easing: easing
        });
        _this3.animate({
          key: "end",
          to: 1,
          duration: duration,
          easing: easing
        });
      }));
      this._disposers.push(startGrip.events.on("pointerdown", function () {
        _this3.setPrivateRaw("isBusy", true);
        _this3._startDown = true;
        _this3._gripDown = "start";
      }));
      this._disposers.push(endGrip.events.on("pointerdown", function () {
        _this3.setPrivateRaw("isBusy", true);
        _this3._endDown = true;
        _this3._gripDown = "end";
      }));
      this._disposers.push(thumb.events.on("pointerdown", function () {
        _this3.setPrivateRaw("isBusy", true);
        _this3._thumbDown = true;
        _this3._gripDown = undefined;
      }));
      this._disposers.push(startGrip.events.on("globalpointerup", function () {
        if (_this3._startDown) {
          _this3.setPrivateRaw("isBusy", false);
        }
        _this3._startDown = false;
      }));
      this._disposers.push(endGrip.events.on("globalpointerup", function () {
        if (_this3._endDown) {
          _this3.setPrivateRaw("isBusy", false);
        }
        _this3._endDown = false;
      }));
      this._disposers.push(thumb.events.on("globalpointerup", function () {
        if (_this3._thumbDown) {
          _this3.setPrivateRaw("isBusy", false);
        }
        _this3._thumbDown = false;
      }));
      this._disposers.push(startGrip.on("x", function () {
        _this3._updateThumb();
      }));
      this._disposers.push(endGrip.on("x", function () {
        _this3._updateThumb();
      }));
      this._disposers.push(startGrip.on("y", function () {
        _this3._updateThumb();
      }));
      this._disposers.push(endGrip.on("y", function () {
        _this3._updateThumb();
      }));
      this._disposers.push(thumb.events.on("positionchanged", function () {
        _this3._updateGripsByThumb();
      }));
      if (this.get("orientation") == "vertical") {
        startGrip.set("x", 0);
        endGrip.set("x", 0);
        this._disposers.push(thumb.adapters.add("y", function (value) {
          return Math.max(Math.min(Number(value), _this3.height() - thumb.height()), 0);
        }));
        this._disposers.push(thumb.adapters.add("x", function (_value) {
          return _this3.width() / 2;
        }));
        this._disposers.push(startGrip.adapters.add("x", function (_value) {
          return _this3.width() / 2;
        }));
        this._disposers.push(endGrip.adapters.add("x", function (_value) {
          return _this3.width() / 2;
        }));
        this._disposers.push(startGrip.adapters.add("y", function (value) {
          return Math.max(Math.min(Number(value), _this3.height()), 0);
        }));
        this._disposers.push(endGrip.adapters.add("y", function (value) {
          return Math.max(Math.min(Number(value), _this3.height()), 0);
        }));
      } else {
        startGrip.set("y", 0);
        endGrip.set("y", 0);
        this._disposers.push(thumb.adapters.add("x", function (value) {
          return Math.max(Math.min(Number(value), _this3.width() - thumb.width()), 0);
        }));
        this._disposers.push(thumb.adapters.add("y", function (_value) {
          return _this3.height() / 2;
        }));
        this._disposers.push(startGrip.adapters.add("y", function (_value) {
          return _this3.height() / 2;
        }));
        this._disposers.push(endGrip.adapters.add("y", function (_value) {
          return _this3.height() / 2;
        }));
        this._disposers.push(startGrip.adapters.add("x", function (value) {
          return Math.max(Math.min(Number(value), _this3.width()), 0);
        }));
        this._disposers.push(endGrip.adapters.add("x", function (value) {
          return Math.max(Math.min(Number(value), _this3.width()), 0);
        }));
      }
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      _get(_getPrototypeOf(Scrollbar.prototype), "_updateChildren", this).call(this);
      if (this.isDirty("end") || this.isDirty("start") || this._sizeDirty) {
        this.updateGrips();
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(Scrollbar.prototype), "_changed", this).call(this);
      if (this.isDirty("start") || this.isDirty("end")) {
        var eventType = "rangechanged";
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, {
            type: eventType,
            target: this,
            start: this.get("start", 0),
            end: this.get("end", 1),
            grip: this._gripDown
          });
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "updateGrips",
    value: function updateGrips() {
      var startGrip = this.startGrip;
      var endGrip = this.endGrip;
      var orientation = this.get("orientation");
      var height = this.height();
      var width = this.width();
      if (orientation == "vertical") {
        startGrip.set("y", height * this.get("start", 0));
        endGrip.set("y", height * this.get("end", 1));
      } else {
        startGrip.set("x", width * this.get("start", 0));
        endGrip.set("x", width * this.get("end", 1));
      }
      var valueFunction = this.getPrivate("positionTextFunction");
      var from = Math.round(this.get("start", 0) * 100);
      var to = Math.round(this.get("end", 0) * 100);
      var fromValue;
      var toValue;
      if (valueFunction) {
        fromValue = valueFunction.call(this, this.get("start", 0));
        toValue = valueFunction.call(this, this.get("end", 0));
      } else {
        fromValue = from + "%";
        toValue = to + "%";
      }
      startGrip.set("ariaLabel", this._t("From %1", undefined, fromValue));
      startGrip.set("ariaValueNow", "" + from);
      startGrip.set("ariaValueText", from + "%");
      startGrip.set("ariaValueMin", "0");
      startGrip.set("ariaValueMax", "100");
      endGrip.set("ariaLabel", this._t("To %1", undefined, toValue));
      endGrip.set("ariaValueNow", "" + to);
      endGrip.set("ariaValueText", to + "%");
      endGrip.set("ariaValueMin", "0");
      endGrip.set("ariaValueMax", "100");
    }
  }, {
    key: "_updateThumb",
    value: function _updateThumb() {
      var thumb = this.thumb;
      var startGrip = this.startGrip;
      var endGrip = this.endGrip;
      var height = this.height();
      var width = this.width();
      var x0 = startGrip.x();
      var x1 = endGrip.x();
      var y0 = startGrip.y();
      var y1 = endGrip.y();
      var start = 0;
      var end = 1;
      if (this.get("orientation") == "vertical") {
        if ($type.isNumber(y0) && $type.isNumber(y1)) {
          if (!this._thumbBusy && !thumb.isDragging()) {
            thumb.set("height", y1 - y0);
            thumb.set("y", y0);
          }
          start = y0 / height;
          end = y1 / height;
        }
      } else {
        if ($type.isNumber(x0) && $type.isNumber(x1)) {
          if (!this._thumbBusy && !thumb.isDragging()) {
            thumb.set("width", x1 - x0);
            thumb.set("x", x0);
          }
          start = x0 / width;
          end = x1 / width;
        }
      }
      if (this.getPrivate("isBusy") && (this.get("start") != start || this.get("end") != end)) {
        this.set("start", start);
        this.set("end", end);
      }
      var valueFunction = this.getPrivate("positionTextFunction");
      var from = Math.round(this.get("start", 0) * 100);
      var to = Math.round(this.get("end", 0) * 100);
      var fromValue;
      var toValue;
      if (valueFunction) {
        fromValue = valueFunction.call(this, this.get("start", 0));
        toValue = valueFunction.call(this, this.get("end", 0));
      } else {
        fromValue = from + "%";
        toValue = to + "%";
      }
      thumb.set("ariaLabel", this._t("From %1 to %2", undefined, fromValue, toValue));
      thumb.set("ariaValueNow", "" + from);
      thumb.set("ariaValueText", from + "%");
    }
  }, {
    key: "_updateGripsByThumb",
    value: function _updateGripsByThumb() {
      var thumb = this.thumb;
      var startGrip = this.startGrip;
      var endGrip = this.endGrip;
      if (this.get("orientation") == "vertical") {
        var thumbSize = thumb.height();
        startGrip.set("y", thumb.y());
        endGrip.set("y", thumb.y() + thumbSize);
      } else {
        var _thumbSize = thumb.width();
        startGrip.set("x", thumb.x());
        endGrip.set("x", thumb.x() + _thumbSize);
      }
    }
  }]);
  return Scrollbar;
}(Container);
Object.defineProperty(Scrollbar, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Scrollbar"
});
Object.defineProperty(Scrollbar, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Scrollbar.className])
});